import DataCardLoader from 'components/DataCardComponent/Loader'
import React from 'react'

interface ICardRendrerProps {
  loading: boolean
  loaderStyle: string
  mainComponent: JSX.Element
}
export default function CardRendrer({ loading,loaderStyle,mainComponent }: ICardRendrerProps) {
  if (loading) {
    return <DataCardLoader mainContainerStyle={loaderStyle} />
  } else {
    return mainComponent
  }
}
